/**
 * Объект целей для клубной записи
 * @typedef {object} ClubYandexGoals
 *
 * @property {string} clickClubSlot - Переход по слоту клуба
 * @property {string} appointmentForm - Переход в форму записи, где есть клуб
 * @property {string} infoModalGlobal - Открытие модального окна с информацией
 * @property {string} selectedPaymentTabClub - Нажатие на кнопку записаться с оплатой через клуб
 * @property {string} selectedPaymentTabLpu - Нажатие на кнопку записаться с оплатой в клинике
 * @property {string} appointmentSuccess - Экран успеха с таймером скидки
 * @property {string} clickPaymentButton - Нажатие на кнопку оплатить
 * @property {string} sendPaymentEmail - Нажатие добавить в форме email
 * @property {string} appointmentOpenPaymentWidget - Открытие виджета на странице успешной записи
 * @property {string} appointmentExpiredTimer - Экран "Вы не успели воспользоваться скидкой"
 * @property {string} paymentPending - Прелоадер "Оплата еще не зачислена"
 * @property {string} paymentSuccess - Экран "Вы в клубе" (общая цель для пользователей с картой и без)
 * @property {string} paymentError - Страница с ошибкой оплаты
 * @property {string} downloadCoupon - Скачать купон на экране успеха
 * @property {string} paymentSuccessRedirectToMedtochka - Нажатие на "Детали записи" на экране успеха
 * @property {string} clickGoWithoutPrepayment - Клик по кнопке "Пойду по обычной цене"
 * @property {string} sendPaymentEmailUserWithoutCard - Успешная отправка email (для пользователей без карты, которые будут ее приобретать)
 */

/** @type {ClubYandexGoals} */
const CLUB_YANDEX_GOALS = {
  clickClubSlot: 'club__clickClubSlot',
  appointmentForm: 'club__appointmentForm',
  infoModalGlobal: 'club__infoModalGlobal',
  selectedPaymentTabClub: 'club__selectedPaymentTabClub',
  selectedPaymentTabLpu: 'club__selectedPaymentTabLpu',
  appointmentSuccess: 'club__appointmentSuccess',
  clickPaymentButton: 'club__clickPaymentButton',
  sendPaymentEmail: 'club__sendPaymentEmail',
  appointmentOpenPaymentWidget: 'club__appointmentOpenPaymentWidget',
  appointmentExpiredTimer: 'club__appointmentExpiredTimer',
  paymentPending: 'club__paymentPending',
  paymentSuccess: 'club__paymentSuccess',
  paymentError: 'club__paymentError',
  downloadCoupon: 'club__downloadCoupon',
  paymentSuccessRedirectToMedtochka: 'club__paymentSuccessRedirectToMedtochka',
  clickGoWithoutPrepayment: 'club__clickGoWithoutPrepayment',
  sendPaymentEmailUserWithoutCard: 'club__sendPaymentEmailUserWithoutCard',
}

export default CLUB_YANDEX_GOALS
